import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';

import SearchInput from '../../../../../../components/common-inputs/SearchInput';
import { changeTableSettings } from '../../../../../../redux/settings/id8/Id8SettingsReducer';

import scss from '../AgentList.module.scss';
import WithLabel, { LABEL_STYLES } from '../../../../../../components/with-label/WithLabel';
import CommonButton, { BUTTON_STYLES } from '../../../../../../components/common-button/CommonButton';
import Icon from '../../../../../../icons/Icon';
import { ICONS } from '../../../../../../icons';
import CommonDropdown from '../../../../../../components/common-dropdown/CommonDropdown';
import { COMMON_PAGE_SIZE_OPTIONS } from '../../../../../../constants';

function AgentFilters() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { t } = useTranslation('settings');

  const { search, size } = useSelector((state) => state.id8Settings.tableSettings);

  const handleSearchChange = (newSearch) => {
    dispatch(changeTableSettings({ search: newSearch, page: 0 }));
  };

  const handleChangeTableSize = (newSize) => {
    dispatch(changeTableSettings({ size: newSize, page: 0 }));
  };

  const handleAddNewAgent = () => {
    navigate('/settings/id8/create-agent');
  };

  return (
    <div className={scss.filtersWrapper}>
      <div className={scss.leftSide}>
        <SearchInput value={search} onChange={handleSearchChange} size='sm' maxWidth={320} />

        <WithLabel label={t('show')} variant={LABEL_STYLES.ROW} isBold maxWidth={150}>
          <CommonDropdown options={COMMON_PAGE_SIZE_OPTIONS} value={size} onSelect={handleChangeTableSize} />
        </WithLabel>
      </div>

      <CommonButton styleColor={BUTTON_STYLES.PRIMARY} onClick={handleAddNewAgent} maxWidth={180}>
        <Icon icon={ICONS.CirclePlus} />
        {t('addAgent')}
      </CommonButton>
    </div>
  );
}

export default AgentFilters;
